import { Navigate, createFileRoute, useRouter, useRouterState } from '@tanstack/react-router'
import { useSession } from '@/lib/auth-client'
import { PlaygroundLayout } from '@/features/playground/components/PlaygroundLayout'
import { generateLinks, generateMetaTags, routeSEO } from '@/lib/seo'

export const Route = createFileRoute('/playground')({
  head: () => ({
    meta: generateMetaTags(routeSEO['/playground']),
    links: generateLinks(routeSEO['/playground']),
  }),
  component: PlaygroundPage,
})

function PlaygroundPage() {
  const { data: session, isPending } = useSession()
  const router = useRouter()
  const matches = useRouterState({ select: (s) => s.matches })
  const threadId =
    (matches.find((m) => (m.params as Record<string, string>)?.threadId) as any)?.params
      ?.threadId ?? null

  if (isPending) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--color-bg-primary)]">
        <div className="glass-panel rounded-full px-6 py-3 text-lg text-[var(--color-text-secondary)] animate-pulse">
          Loading...
        </div>
      </div>
    )
  }

  if (!session) {
    const currentLocation = router.state.location
    const pathname = currentLocation.pathname
    const search =
      typeof currentLocation.searchStr === 'string' ? currentLocation.searchStr : ''
    return <Navigate to="/sign-in" search={{ continue: `${pathname}${search}` }} />
  }

  return <PlaygroundLayout activeUrlThreadId={threadId} />
}
